/**
 * Internal dependencies
 */
import WMUFieldRecaptcha from "./field-recaptcha";

/**
 * 
 * @param {HTMLElement} contextElement 
 */
const initRecaptcha = ( contextElement = null ) =>
{
	if ( null === contextElement )
	{
		contextElement = document;
	}

	contextElement.querySelectorAll( 'input[data-recaptcha]' ).forEach( ( inputElement ) =>
	{
		const fieldRecaptcha = new WMUFieldRecaptcha( inputElement );
	} );
};

/**
 * 
 */
document.addEventListener( 'DOMContentLoaded', ( event ) =>
{
	if ( typeof grecaptcha == 'undefined' )
	{
		console.warn( "reCAPTCHA object is not loaded." );
	}

	initRecaptcha();
} );

/**
 * 
 */
window.addEventListener( 'wmu/newElements', ( event ) =>
{
	if ( event && event.detail && event.detail.elements && event.detail.elements.length )
	{
		event.detail.elements.forEach( ( element ) =>
		{
			initRecaptcha( element );
		} );
	}
} );